// 手机端断点：明细改抽屉展示，避免窄屏表格出现横向滚动
export default {
  data: () => ({
    isMobileScreen: false,
    mediaQuery: null,
  }),
  created() {
    if (!window.matchMedia) return;
    this.mediaQuery = window.matchMedia('(max-width: 768px)');
    this.isMobileScreen = this.mediaQuery.matches;
    this.handleMediaChange = (event) => {
      this.isMobileScreen = event.matches;
    };
    this.mediaQuery.addListener(this.handleMediaChange);
  },
  beforeDestroy() {
    if (this.mediaQuery) this.mediaQuery.removeListener(this.handleMediaChange);
  },
};
